import _ from 'lodash';
import React, {Fragment} from 'react';
import config from 'client/shared/config';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';
import { DeleteButton } from 'client/shared/components';

import OptionsButton from './options-button';
import SubscriptionModal from '../artist/subscribe-modal';


@inject('songsStore', 'artistStore', 'userStore', 'apiStore')
@observer
export default class SongOptions
extends React.Component {
	constructor(props) {
		super(props);
		this.state = {active: false}
		this.subModalRef = React.createRef();
	}
	render () {
		const { song, songsStore, artistStore, userStore, optionsTheme = 'dark', rollover= 'true'} = this.props;
		const user = userStore.getLoggedInUser();
		const artist = artistStore.getArtistByID(song.artistID);
		const isFav = user.isHiFived(song.id);
		const isSub = user.getSubscription(song.artistID);

		console.log(`Active is: ${this.state.active} `)
		return (
			<div style={{position: 'absolute'}}>
				{/* <OptionsButton
					menuOnLeft
					onClick={ this.onClick }
					onBlur={this.onBlur}
					className={ `list-options left ${ optionsTheme }` }
				> */}
					{/* { this.state.active &&
						(song.id === songsStore.activeSongRowID ?
							this.renderOptions(isFav) : null)
					} */}
				{/* </OptionsButton> */}
				{ this.renderOptions(isFav, isSub, artist)}
				

			</div>
		);
	}

	renderOptions (favoriteFlag, subbedFlag, artist) {
		return (
			<div>
				{
					subbedFlag &&
					this.renderListButton({
						icon: 'fal fa-arrow-to-bottom',
						label: 'Download Song',
						ariaLabel: 'download',
						onClick: this.onDownloadClick
					})
				}
				{
					!subbedFlag &&
					(<SubscriptionModal ref={this.subModalRef} menuMode={true} artist={ artist } />)
					
				}
				{/* {
					this.renderListButton({
						icon: 'fas fa-plus',
						label: 'Add to Playlist',
						ariaLabel: 'playlist',
						// onClick: this.onRemoveHiFiveClick
					})
				} */}
				{/* {
					!favoriteFlag &&
					this.renderListButton({
						icon: 'fas fa-heart',
						label: 'Add to My Favorites',
						ariaLabel: 'favorite',
						onClick: this.onHiFiveClick
					})
				} */}
				{/* {
					favoriteFlag &&
					this.renderListButton({
						icon: 'fas fa-heart-broken',
						label: 'Remove from My Favorites',
						ariaLabel: 'unfavorite',
						onClick: this.onRemoveHiFiveClick

					})
				} */}
				{/* {
					this.renderListButton({
						icon: 'fas fa-share-alt',
						label: 'Share',
						// onClick: this.onRemoveHiFiveClick
					})
				} */}
			</div>
		);
	}

	@autobind
	renderListButton ({
		icon,
		position,
		onClick,
		label,
		className = '',
		ariaLabel,
		attrs = {}
	}) {
		return (
			<div key={ position }>
				<button
					aria-label={ariaLabel}
					{ ...attrs }
					onClick={ onClick }
					className={ `button tertiary clear margin-bottom-0 ${className}` }
				>
					<span className={ `${icon} icon` }></span> { label }
				</button>
			</div>
		);
	}

	@autobind
	onClick (evt) {
		const { songsStore, song } = this.props;
		songsStore.activeSongRowID = (songsStore.activeSongRowID === song.id) ? null : song.id;
		console.log("ACTIVE");
		this.setState({active: true});

		evt.stopPropagation();
	}

	@autobind
	onBlur (evt) {
		console.log("NO LONGER ACTIVE");
		this.setState({active: false});

		switch(evt.relatedTarget.ariaLabel) {
			case 'download':
				this.onDownloadClick(evt);
				break;
			case 'playlist':
				break;
			case 'favorite':
				this.onHiFiveClick(evt);
				break;
			case 'subscribe': 
				this.subModalRef.current.handleOpenModal();
				break;
			case 'unfavorite':
				this.onRemoveHiFiveClick(evt);
				break;
			case null:
				break;
		}
		// evt.stopPropagation();
	}

	@autobind
	async onDownloadClick (evt) {
		evt?.stopPropagation?.();
		const { song, apiStore } = this.props;
		if (!song?.artistID || !song?.id) return;

		try {
			// BFF returns a presigned S3 URL scoped to this user's subscription.
			// The server sets ResponseContentDisposition=attachment on the URL,
			// so hitting it triggers a browser download rather than inline play.
			const route = `${config.apiBase}/bff/members/audio-url/${song.artistID}/${song.id}/download`;
			const { url } = await apiStore.fetch({ route });
			if (!url) throw new Error('No download URL returned');

			// Programmatic click on a hidden anchor is the most reliable
			// cross-browser way to kick off a download without navigating.
			const a = document.createElement('a');
			a.href = url;
			a.download = `${(song.title || 'song').replace(/[^a-zA-Z0-9 _.-]/g, '_')}.mp3`;
			a.rel = 'noopener';
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
		} catch (err) {
			console.error('[ERROR: SongOptions.onDownloadClick]', err);
		}
	}

	@autobind
	async onHiFiveClick (evt) {
		const { song, userStore } = this.props;
		const user = userStore.getLoggedInUser();
		const hiFiveData = await song.hiFive(user.id);
		user.hiFived.push(hiFiveData);
		// evt.stopPropagation();

	}

	@autobind
	onRemoveHiFiveClick (evt) {
		const { song, userStore, apiStore } = this.props;
		const user = userStore.getLoggedInUser();
		const { id } = _(user.hiFived).filter({ itemID: song.id }).first();
		const route = `${config.getRoute('hiFive')}/${id}`;
		apiStore.delete({ route });
		user.hiFived = _.remove(user.hiFived.slice(), { id });
		// evt.stopPropagation();
	}

	clearActiveSong () {
		this.props.songsStore.activeSongRowID = null;
	}
}
